import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { TFMService } from 'app/mock-api/tfm.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const tfmService: TFMService = inject(TFMService);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) =>
        {
            // B2C/client sites: do not show platform auth pages (sign-in, sign-up, etc.); send users to home.
            const isPlatformAuthUrl = /^\/(sign-in|sign-up|forgot-password|reset-password|confirmation-required)(\?|$)/.test(state.url);
            if ( tfmService.view.isClient && isPlatformAuthUrl )
            {
                return of(router.parseUrl('/'));
            }

            // On platform mode, only redirect root URL to dashboard when already authenticated.
            // When not authenticated, allow access so the landing page can show (user can sign in from there).
            const isRootUrl = state.url === '/' || state.url === '' || state.url.startsWith('/?');
            if ( !tfmService.view.isClient && isRootUrl && authenticated )
            {
                return of(router.parseUrl('/dashboard'));
            }

            // If the user is authenticated...
            if ( authenticated )
            {
                //return of(router.parseUrl(''));
            }

            // Allow the access
            return of(true);
        }),
    );
};
